export const messages = {
  en: {
    monthAttendance: {
      search: {
        title: 'Search Conditions',
        classes: 'Classes',
        selectClasses: 'Please select classes',
        staffName: 'Staff Name',
        inputStaffName: 'Please input staff name',
        date: 'Date',
        selectDate: 'Please select date'
      },
      table: {
        title: 'Monthly Attendance',
        classes: 'Classes',
        staffName: 'Staff Name',
        clockIn: 'Normal Attendance',
        late: 'Late',
        early: 'Leave Early',
        noClockIn: 'Absenteeism',
        free: 'No Need Attendance'
      },
      work: 'Work',
      offWork: 'Off Work',
      notTime: 'Not time yet',
      noNeed: 'No need attendance',
      fetchError: 'Failed to fetch attendance data',
      fetchClassesError: 'Failed to fetch classes data',
      exportSuccess: 'Export successfully',
      exportError: 'Failed to export'
    }
  },
  zh: {
    monthAttendance: {
      search: {
        title: '查询条件',
        classes: '班次',
        selectClasses: '请选择班次',
        staffName: '员工名称',
        inputStaffName: '请输入员工名称',
        date: '打卡时间',
        selectDate: '请选择打卡时间'
      },
      table: {
        title: '月考勤',
        classes: '考勤组',
        staffName: '员工名称',
        clockIn: '正常考勤',
        late: '迟到',
        early: '早退',
        noClockIn: '旷工',
        free: '免考勤'
      },
      work: '上班',
      offWork: '下班',
      notTime: '未到时间',
      noNeed: '无需考勤',
      fetchError: '获取考勤数据失败',
      fetchClassesError: '获取班次数据失败',
      exportSuccess: '导出成功',
exportError: '导出失败'
    }
  },
  'zh-TW': {
    monthAttendance: {
      search: {
        title: '查詢條件',
        classes: '班次',
        selectClasses: '請選擇班次',
        staffName: '員工名稱',
        inputStaffName: '請輸入員工名稱',
        date: '打卡時間',
        selectDate: '請選擇打卡時間'
      },
      table: {
        title: '月考勤',
        classes: '考勤組',
        staffName: '員工名稱',
        clockIn: '正常考勤',
        late: '遲到',
        early: '早退',
        noClockIn: '曠工',
        free: '免考勤'
      },
      work: '上班',
      offWork: '下班',
      notTime: '未到時間',
      noNeed: '無需考勤',
      fetchError: '獲取考勤數據失敗',
      fetchClassesError: '獲取班次數據失敗',
      exportSuccess: '導出成功',
      exportError: '導出失敗'
    }
  }
}